import React, { useState } from "react";
import { Link } from "react-router-dom"; 
import logo from "../assets/logobg.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          font-family: Arial, sans-serif;
        }

        /* ===== NAVBAR (OVER HERO + SCROLL AWAY) ===== */
        .navbar {
          position: absolute;
          top: 20px;
          left: 0;
          width: 100%;
          z-index: 1000;

          display: flex;
          justify-content: center;
          padding: 0 12px;
        }

        .navbar-container {
          width: 100%;
          max-width: 950px;

          display: flex;
          align-items: center;
          justify-content: space-between;

          padding: 6px 16px; /* reduced height */
          border-radius: 18px;

          background: rgba(255, 255, 255, 0.12);
          backdrop-filter: blur(14px);

          border: 1px solid rgba(255, 255, 255, 0.25);

          box-shadow: 
            0 10px 40px rgba(0, 0, 0, 0.15),
            0 0 0 1px rgba(255,255,255,0.08);
        }

        /* LOGO FIX */
        .logo {
          display: flex;
          align-items: center;
        }

        .logo img {
          height: 50px; /* increased */
          width: auto;
        }

        /* NAV LINKS */
        .nav-links {
          display: flex;
          gap: 24px;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .nav-links a {
          color: white;
          text-decoration: none;
          font-size: 14px;
          transition: 0.3s;
        }

        .nav-links a:hover {
          color: #D4AF37;
        }

        /* CTA */
        .cta-btn {
          background: #7ED957;
          color: black;
          padding: 8px 16px;
          border-radius: 999px;
          font-size: 14px;
          text-decoration: none;
        }

        /* MENU ICON */
        .menu-icon {
          display: none;
          font-size: 22px;
          color: white;
          cursor: pointer;
        }

        /* SIDEBAR */
        .sidebar {
          position: fixed;
          top: 0;
          left: -100%;
          width: 80%;
          max-width: 300px;
          height: 100%;
          background: white;
          z-index: 2000;
          transition: 0.3s ease;
          padding: 20px;
        }

        .sidebar.open {
          left: 0;
        }

        .sidebar-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .sidebar-header img {
          height: 40px;
        }

        .sidebar-header button {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
        }

        .sidebar-links {
          margin-top: 30px;
          list-style: none;
          padding: 0;
        }

        .sidebar-links a {
          display: block;
          padding: 15px 0;
          font-size: 18px;
          text-decoration: none;
          color: black;
          border-bottom: 1px solid #eee;
        }

        .overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.4);
          z-index: 1500;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .nav-links,
          .cta-btn {
            display: none;
          }

          .menu-icon {
            display: block;
          }
        }

        @media (max-width: 500px) {
          .logo img {
            height: 44px;
          }

          .navbar-container {
            padding: 5px 12px;
          }
        }
      `}</style>

      {/* NAVBAR */}
      <nav className="navbar">
        <div className="navbar-container">

          <div className="logo">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </div>

          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>

         <a href="tel:+919151622122" className="cta-btn">
  Book Call ↗
</a>

          <div className="menu-icon" onClick={() => setMenuOpen(true)}>
            ☰
          </div>
        </div>
      </nav>

      {/* SIDEBAR */}
      <div className={`sidebar ${menuOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <img src={logo} alt="Logo" />
          <button onClick={() => setMenuOpen(false)}>✕</button>
        </div>

        <ul className="sidebar-links">
          <li><Link to="/" onClick={()=>setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={()=>setMenuOpen(false)}>About</Link></li>
          <li><Link to="/pricing" onClick={()=>setMenuOpen(false)}>Pricing</Link></li>
          <li><Link to="/contact" onClick={()=>setMenuOpen(false)}>Contact</Link></li>
        </ul>
      </div>

      {menuOpen && (
        <div className="overlay" onClick={() => setMenuOpen(false)}></div>
      )}
    </>
  );
};

export default Navbar;